import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
`;

export default { Wrap };
